var _path, _circle, _circle2, _rect, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg60Min(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1022 2.27257C18.1022 1.01746 19.1197 0 20.3748 0C21.6299 0 22.6474 1.01746 22.6474 2.27257V2.95044C31.8446 4.0711 38.9688 11.9069 38.9688 21.4067C38.9688 31.6758 30.6441 40.0005 20.375 40.0005C10.106 40.0005 1.78125 31.6758 1.78125 21.4067C1.78125 17.0583 3.27399 13.0584 5.77499 9.89172L5.44177 9.58264C4.52157 8.7291 4.46753 7.2912 5.32107 6.371C6.1746 5.4508 7.6125 5.39676 8.5327 6.2503L9.00792 6.69109C11.586 4.69673 14.7025 3.36482 18.1022 2.95049V2.27257Z",
    fill: "#272727"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.3754,
    cy: 21.3951,
    r: 16.5278,
    transform: "rotate(-90 20.3754 21.3951)",
    fill: "#C93F37"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.3751,
    cy: 21.3949,
    r: 4.13195,
    transform: "rotate(-90 20.3751 21.3949)",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.3423,
    y: 7.4751,
    width: 2.06597,
    height: 12.3575,
    rx: 1.03299,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.3749,
    cy: 21.3949,
    r: 1.56259,
    transform: "rotate(-180 20.3749 21.3949)",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg60Min);
export default __webpack_public_path__ + "static/media/60min.ecf92802757958da46fe5de5b476d57c.svg";
export { ForwardRef as ReactComponent };